import { useState, useRef } from "react";
import { useMutation, gql } from "@apollo/client";

const FORGOT_PASSWORD_RIDER = gql`
  mutation ForgotPasswordRider($email: EmailAddress!) {
    forgotPasswordRider(email: $email) {
      message
    }
  }
`;

const FORGOT_PASSWORD_DRIVER = gql`
  mutation ForgotPasswordDriver($email: EmailAddress!) {
    forgotPasswordDriver(email: $email) {
      message
    }
  }
`;

function ForgotPassword({ isDriver }) {
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const emailRef = useRef();

  const [forgotPasswordRider, { loading: loadingRider }] = useMutation(FORGOT_PASSWORD_RIDER);
  const [forgotPasswordDriver, { loading: loadingDriver }] = useMutation(FORGOT_PASSWORD_DRIVER);

  const loading = loadingRider || loadingDriver;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const email = emailRef.current.value;
    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    try {
      const mutation = isDriver ? forgotPasswordDriver : forgotPasswordRider;
      await mutation({ variables: { email } });
      setSubmitted(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
  };

  if (submitted) {
    return (
      <div className="flex flex-col items-center text-center py-4">
        <div className="w-12 h-12 mb-3 rounded-full bg-green-500/20 flex items-center justify-center">
          <span className="text-green-400 text-2xl">✓</span>
        </div>
        <h3 className="text-highlight-blue text-xl mb-2">Check Your Email</h3>
        <p className="text-white/70 text-sm px-4">
          If an account with that email exists, we've sent a password reset link.
          The link expires in 1 hour.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col w-full center-all">
      <h3 className="text-highlight-blue pt-6 pb-2 text-xl">
        Reset Password
      </h3>
      <p className="text-white/70 text-sm mb-4 text-center px-4">
        Enter the email address associated with your {isDriver ? "driver" : "rider"} account.
      </p>

      <input
        type="email"
        ref={emailRef}
        placeholder="Email"
        className="modal-input-layout modal-input-border"
      />

      {error && (
        <p className="mt-2 text-sm text-red-500">{error}</p>
      )}

      <button
        type="submit"
        disabled={loading}
        className="btn btn-green btn-md mt-2"
      >
        {loading ? "Sending..." : "Send Reset Link"}
      </button>
    </form>
  );
}

export default ForgotPassword;
